<template>
  <RouterView />
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({})
</script>
